import * as yup from 'yup'

const AddUserRoleValidationSchema = yup.object().shape({
    buyerSeller: yup.number().required('Please select buyerSeller type'),
    companyId: yup.number().required('Please select company'),
    branchId: yup.number().required('Please select branch'),
    companyRoleId: yup.number().required('Please select role'),
    //managerId: yup.number().required('Please select manager'),
})

export { AddUserRoleValidationSchema };